import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import GoogleMapPin from './GoogleMapPin';
import './googleMap.css';

const GoogleMap = ({ pinLocation, zoomLevel }) => {
  const getMapOptions = () => {
    return {
      mapTypeControl: true,
      streetViewControl: true
    };
  };

  return (
    <div className="map">
      <div className="google-map">
        <GoogleMapReact
          bootstrapURLKeys={{ key: import.meta.env.VITE_GOOGLE_MAP_API }}
          defaultCenter={pinLocation}
          defaultZoom={zoomLevel}
          options={getMapOptions}
        >
          <GoogleMapPin
            lat={pinLocation.lat}
            lng={pinLocation.lng}
            info={pinLocation.address}
          />
        </GoogleMapReact>
      </div>
    </div>
  );
};

GoogleMap.propTypes = {
  pinLocation: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    address: PropTypes.string
  }).isRequired,
  zoomLevel: PropTypes.number.isRequired
};

export default GoogleMap;
